import React, { Component, useState } from "react";
import { default as content } from '../content/en'

export default function BasketSnippet({
  planPrice,
  stepNumber,
  customerSelections,
  setCustomerSelections,
  userPlan,
  simType,
  basket,
  discount,
}) {

  const frequency =
    userPlan.validity > 1
      ? userPlan.validity + " " + userPlan.validityUnit
      : userPlan.validityUnit.replace(/s$/, "");

  return (
    <>
      <div className="basket-snippet">
        <div className="step-header">
          <h2>{content.basketSnippet.h2}</h2>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', padding: 12, marginRight: 12 }}>
          <div class='flex-row'>
            <div style={{ flex: 1, minWidth: '100px' }}>Plan</div>
            <div style={{ flex: 2 }}>{userPlan.name}</div>
          </div>
          <div class='flex-row'>
            <div style={{ flex: 1, minWidth: '100px' }}>Plan Price</div>
            <div style={{ flex: 2 }}>£{(userPlan.price / 100).toFixed(2)} / {frequency}</div>
          </div>
          {customerSelections["Validate Email"].stepDescription &&
            <div class='flex-row'>
              <div style={{ flex: 1, minWidth: '100px' }}>Email</div>
              <div style={{ flex: 2, wordBreak: 'break-all' }}>{customerSelections["Validate Email"].stepDescription}</div>
            </div>
          }
          {discount &&
            <div class='flex-row'>
              <div style={{ flex: 1, minWidth: '100px' }}>Discount</div>
              <div style={{ flex: 2 }}>{discount.name}</div>
            </div>
          }
        </div>
        <div className="card-footer" style={{ flexWrap: 'wrap', paddingBottom: 12 }}>
          <h1>{content.basketSnippet.total}</h1>
          <p>£{(planPrice / 100).toFixed(2)}</p>
          {discount && <p style={{ paddingTop: 12, fontSize: 12, width: '100%' }}>{content.basketSnippet.discountAppliedBasketSnippet}</p>}
        </div>
      </div>
    </>
  );
}
